import { useState, useEffect } from "react";

/**
 * Returns false on first render (matches server output), then true after hydration.
 * Use this instead of `typeof window === "undefined"` in render logic to prevent
 * hydration mismatches.
 */
export default function useIsHydrated() {
  const [isHydrated, setIsHydrated] = useState(false);
  useEffect(() => setIsHydrated(true), []);
  return isHydrated;
}
